import { Card, Row, Col, Divider } from 'antd';
import PropTypes from 'prop-types';
import {
	LRViewHeader,
	LRViewAddress,
	LRBarCode,
	LRViewSummary,
	LRViewGoodsDetails,
	LRViewSignatureBlock,
	LRDeclaration,
} from './components';

function cleanDetails(details) {
	const clearKeys = [
		'sender_name',
		'sender_pincode',
		'receiver_name',
		'receiver_pincode',
		'declared_value',
		'goods_description',
		'gross_weight',
		'vehicle_number',
		'ewb_number',
		'client_reference_numbers',
	];
	const summaryItems = {};
	clearKeys.forEach((key) => {
		if (key in details && details[key]) {
			summaryItems[key] = String(details[key]).trim();
		}
	});
	return summaryItems;
}

export function LRCopy({ details, title }) {
	return (
		<Card size="small">
			<div
				style={{
					position: 'absolute',
					width: '100%',
					height: '100%',
					// background: 'rgba(12,12,12,0.1)',
					color: 'rgba(12,12,12,0.3)',
					margin: '0px',
					zIndex: 1,
					textAlign: 'center',
					alignContent: 'center',
					display: !details.soft_delete && 'none',
				}}
			>
				<div style={{ transform: 'rotate(-50deg)', fontSize: '120px' }}>CANCELLED</div>
			</div>
			<LRViewHeader details={details} title={title} />
			<Divider />
			<Row>
				<Col span={12}>
					<LRViewAddress
						addressType="Sender"
						partyName={details.sender_name}
						partyAddress={details.sender_address}
						partyPincode={details.sender_pincode}
					/>
				</Col>
				<Col span={12}>
					<LRBarCode value={`CSN${String(details.id).padStart(6, '0')}`} />
				</Col>
			</Row>
			<Divider />
			<Row>
				<Col span={12}>
					<LRViewAddress
						addressType="Receiver"
						partyName={details.receiver_name}
						partyAddress={details.receiver_address}
						partyPincode={details.receiver_pincode}
					/>
				</Col>
				<Col span={12}>
					<LRViewSummary details={cleanDetails(details)} />
				</Col>
			</Row>
			<Divider />
			<Row>
				<Col span={12}>
					<LRDeclaration />
				</Col>
				<Col span={12}>
					<Row gutter={20} justify="center">
						<Col>
							<LRViewGoodsDetails Items={details?.goods_details} />
						</Col>
					</Row>
				</Col>
			</Row>
			<Row justify="space-evenly">
				<div />
				<Col span={8}>
					<LRViewSignatureBlock title="Transporter" />
				</Col>
				<Col span={8}>
					<LRViewSignatureBlock title="Sender" />
				</Col>
				<Col span={8}>
					<LRViewSignatureBlock title="Receiver" />
				</Col>
			</Row>
		</Card>
	);
}

LRCopy.propTypes = {
	details: PropTypes.object,
	title: PropTypes.string,
};
